import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {AutoComplete} from "primereact/autocomplete";
import {Dropdown} from "primereact/dropdown";

const MaterialcategoryFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [employees, setEmployees] = useState([]);
  const [notifiedByDisplay, setNotifiedByDisplay] = useState("");
  const [notifiedBySuggestions, setNotifiedBySuggestions] = useState([]);

  const valueMaterialGeometryOptions = [
    { value: 'mandatory', key: 'Kötelező' },
    { value: 'optional', key: 'Opcionális' },
    { value: 'disabled', key: 'Kikapcsolva' }
  ];

  // const validate = (data) => {
  //   let errors = {};
  //   return errors;
  // };
  const validate = (data) => {
    let errors = {};
    if (!data.name) errors.name = 'Ez az érték nem lehet üres.';
    if (!data.purchase_order_request_notification && !notifiedByDisplay) {
        errors.purchase_order_request_notification = 'Ez az érték nem lehet üres.';
    }
    return errors;
  };

  const searchEmployee = (event) => {
    const q = (event.query || "").toLowerCase().trim();
    if (!q) return setNotifiedBySuggestions([]);
    const filtered = employees
      .filter(e => (e.name || "").toLowerCase().includes(q))
      .map(e => ({ ...e, name: e.name }));
    setNotifiedBySuggestions(filtered);
  };

  const onSubmit = (data, form) => {
    setLoading(true)
    if (id) {
      apiCall('patch', '/api/v2/material-category/' + (window.App.urlVars().materialcategoryId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderMaterialcategoryList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/material-category', formData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderMaterialcategoryList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/inventory/material-category/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!((meta.touched || meta.submitFailed) && (meta.error || meta.submitError));

  const getFormErrorMessage = (meta) => {
      return isFormFieldValid(meta) && <small className="p-error">{meta.error || meta.submitError}</small>;
  };

  const clearInjectedError = (id) => {
    const element = document.getElementById(id);
    if (!element) return;
    element.classList.remove('p-invalid');
    const innerInput = element.querySelector('input');
    if (innerInput) innerInput.classList.remove('p-invalid');
    const container = element.closest('.p-field');
    if (container) {
        let next = container.nextElementSibling;
        while (next && next.tagName === 'SMALL' && next.classList.contains('p-error')) {
            const toDelete = next;
            next = next.nextElementSibling;
            toDelete.remove();
        }
    }
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/employee?limit=9999')
      .then(response => {
        const list = response.data?.data?.items || [];
        setEmployees(list);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().materialcategoryId) || (entity === 'material-category' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/material-category/' + (window.App.urlVars().materialcategoryId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  useEffect(() => {
    const v = formData?.purchase_order_request_notification;
    if (!v || !employees || employees.length === 0) {
      return;
    }
    if (typeof v === 'object') {
      setNotifiedByDisplay(v.name || "");
    } else {
      const hit = employees.find(e => String(e.id) === String(v));
      if (hit) {
        setNotifiedByDisplay(hit.name || "");
      }
    }
  }, [formData?.purchase_order_request_notification, employees]);

  useEffect(() => {
    const vars = window.App.urlVars();
    if (vars.employeeName) {
      const name = decodeURIComponent(vars.employeeName);
      setNotifiedByDisplay(name);

      setFormData(prev => ({
        ...prev,
        purchase_order_request_notification: vars.employeeId || prev.purchase_order_request_notification
      }));
      setNewFormData(prev => ({
        ...prev,
        purchase_order_request_notification: vars.employeeId || prev.purchase_order_request_notification
      }));
    }
  }, [window.App.urlVars().employeeName]);

  return (
    <div className={"materialcategory-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   input.onChange(e.target.value)
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_PURCHASE_ORDER_READ') && (
            <div className={"p-col-12 p-lg-4"}>
              <Field name="purchase_order_request_notification" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="purchase_order_request_notification"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPurchaseOrderRequestNotification')}</label>
                   <span className="p-inputgroup">
                    <Button
                      type="button"
                      className="p-button"
                      onClick={() => {
                        let paramsObj = { ...window.App.urlVars() };
                        paramsObj.search = 'employee';
                        let query = "?";
                        Object.entries(paramsObj).forEach(([k,v]) => { query += k + "=" + v + "&"; });
                        history.push(window.location.hash.replace("#","") + query);
                      }}
                    >
                      <i className="pi pi-search"></i>
                    </Button>

                    <AutoComplete
                      id="purchase_order_request_notification"
                      {...input}
                      value={notifiedByDisplay}
                      suggestions={notifiedBySuggestions}
                      completeMethod={searchEmployee}
                      field={"name"}
                      delay={800}
                      forceSelection
                      placeholder={t('typeToSearchPlaceholder')}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      onSelect={(e) => {
                        const picked = e.value;
                        setNotifiedByDisplay(picked.name || "");
                        input.onChange(picked.id);
                        clearInjectedError("purchase_order_request_notification");
                        setFormData({
                          ...formData,
                          purchase_order_request_notification: picked.id
                        });
                        setNewFormData({
                          ...newFormData,
                          purchase_order_request_notification: picked.id
                        });
                      }}
                      onChange={(e) => {
                        setNotifiedByDisplay(e.value || "");
                        input.onChange(e.value);
                        setFormData({ ...formData, purchase_order_request_notification: null });
                        setNewFormData({ ...newFormData, purchase_order_request_notification: null });
                      }}
                      onClear={() => {
                        setNotifiedByDisplay("");
                        setFormData({ ...formData, purchase_order_request_notification: null });
                        setNewFormData({ ...newFormData, purchase_order_request_notification: null });
                      }}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
            {((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_MATERIAL_PRODUCTION_READ') && (
            <div className={"p-col-12 p-lg-4"}>
              <Field name="value_material_geometry" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="value_material_geometry"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldMaterialGeometry')}</label>
                  <span className="p-d-block">
                    <Dropdown
                      options={window.App.sortDropdownOptions(valueMaterialGeometryOptions, "key")}
                      id={"value_material_geometry"}
                      optionValue={"value"}
                      optionLabel={"key"}
                      emptyMessage={t('noElementYet')}
                      onChange={(e) => {
                        input.onChange(e.value)
                        setFormData({
                          ...formData,
                          value_material_geometry: e.value
                        })
                        setNewFormData({
                          ...newFormData,
                          value_material_geometry: e.value
                        })
                      }}
                      value={formData.value_material_geometry?.id || formData.value_material_geometry}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'material-category' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(MaterialcategoryFormComponent);
